/**
 *  Point of contact for component modules
 *
 *  ie: import { Index, NotFound } from 'views';
 *
 */

export App from './App/App'
export Index from './Index/Index'
export NotFound from './NotFound/NotFound'



// WEBPACK FOOTER //
// ./src/views/index.js